import * as React from 'react';
import Empty from '../Empty';
import NoResults from '../Empty/images/small/NoResults';

var renderEmpty = function renderEmpty(componentName, description) {
  switch (componentName) {
    case 'Table':
    case 'List':
      return /*#__PURE__*/React.createElement(Empty, {
        imageNode: /*#__PURE__*/React.createElement(NoResults, null),
        description: description
      });

    case 'Select':
    case 'TreeSelect':
    case 'Cascader':
    case 'Transfer':
    case 'Mentions':
      return /*#__PURE__*/React.createElement(Empty, {
        imageNode: /*#__PURE__*/React.createElement(NoResults, null),
        description: description
      });

    default:
      return /*#__PURE__*/React.createElement(Empty, null);
  }
};

export default renderEmpty;